import { Button } from '@mui/material';
import { FC, useState } from 'react';

import { InfoModal } from 'components/shared/Modal/Info';

import { ReactComponent as Error } from 'assets/icons/error.svg';
import { ReactComponent as Success } from 'assets/icons/success.svg';

interface OperationResultModalProps {
	title: string;
	description: string;
	confirm: string;
	type: 'success' | 'cancel';
	onClose: () => void;
}

export const OperationResultModal: FC<OperationResultModalProps> = ({
	title,
	description,
	confirm,
	type,
	onClose,
}) => {
	const [open, setOpen] = useState<boolean>(true);

	const handleClose = () => {
		setOpen(false);
		onClose();
	};

	return (
		<InfoModal
			isOpen={open}
			onClose={handleClose}
			image={type === 'success' ? <Success /> : <Error />}
			title={title}
			description={description}
			buttons={
				<Button
					className="not-rtl-able"
					sx={{
						height: '44px',
						width: { xs: '90%', sm: '100%' },
						borderRadius: '8px',
						textTransform: 'none',
						fontSize: '16px',
						fontWeight: '700',
						marginTop: '24px',
						backgroundColor: type === 'success' ? 'rgb(71, 134, 255)' : 'rgb(251, 11, 36)',
						'&:hover': {
							backgroundColor: type === 'success' ? 'rgb(108, 158, 255)' : 'rgb(254, 74, 82)',
						},
					}}
					variant="contained"
					color="primary"
					onClick={handleClose}
				>
					{confirm}
				</Button>
			}
		></InfoModal>
	);
};
